// extracted by css-extract-rspack-plugin
export default {"Wrapper":"FPyKh"};